var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllusTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "240px",
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illus_site") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-43.5%",
    y: "-94.8%",
    width: "187.1%",
    height: "289.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.6,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-52.6%",
    y: "-94.8%",
    width: "205.1%",
    height: "289.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.6,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-52.6%",
    y: "-94.8%",
    width: "205.1%",
    height: "289.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.6,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-14.3637355%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF3FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.8792947,37 L27.1207053,37 C38.0997366,37 47,45.9002634 47,56.8792947 L47,74.5199611 C47.000002,75.9435213 46.2434174,77.259812 45.0133288,77.9763354 C38.1192605,81.9921118 30.9481511,84 23.5000007,84 C16.0518513,84 8.88074266,81.9921124 1.98667461,77.9763372 C0.756584795,77.2598157 1.74335862e-16,75.9435248 0,74.5199644 L0,56.8792947 C-1.34454356e-15,45.9002634 8.90026342,37 19.8792947,37 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-11.7%",
    y: "-7.4%",
    width: "123.4%",
    height: "123.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.07 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-14.3637355%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF4FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-8",
    cx: 23.5,
    cy: 21.5,
    r: 21.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-12.8%",
    y: "-8.1%",
    width: "125.6%",
    height: "125.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.07 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.8792947,37 L27.1207053,37 C38.0997366,37 47,45.9002634 47,56.8792947 L47,74.5199611 C47.000002,75.9435213 46.2434174,77.259812 45.0133288,77.9763354 C38.1192605,81.9921118 30.9481511,84 23.5000007,84 C16.0518513,84 8.88074266,81.9921124 1.98667461,77.9763372 C0.756584795,77.2598157 1.74335862e-16,75.9435248 0,74.5199644 L0,56.8792947 C-1.34454356e-15,45.9002634 8.90026342,37 19.8792947,37 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-11.7%",
    y: "-7.4%",
    width: "123.4%",
    height: "123.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.07 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-12",
    cx: 23.5,
    cy: 21.5,
    r: 21.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-12.8%",
    y: "-8.1%",
    width: "125.6%",
    height: "125.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-13"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.07 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.100492,43 L35.899508,43 C49.2098422,43 60,53.7901578 60,67.100492 L60,89.3373925 C59.9999995,90.5604316 59.4404652,91.7162619 58.4811428,92.4748957 C51.2942552,98.1582986 41.8005409,101 30,101 C18.1994587,101 8.70574413,98.1582984 1.51885643,92.4748951 C0.559534229,91.716261 1.49779099e-16,90.5604307 0,89.3373916 L0,67.100492 C-1.63004582e-15,53.7901578 10.7901578,43 24.100492,43 Z",
    id: "path-14"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-9.2%",
    y: "-6.0%",
    width: "118.3%",
    height: "119.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-16",
    cx: 29.5,
    cy: 25.5,
    r: 25.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.8%",
    y: "-6.9%",
    width: "121.6%",
    height: "121.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-17"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.07 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding-screen-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-520.000000, -192.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(440.000000, 192.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illus_site",
    transform: "translate(80.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#EDF3FA",
    cx: 120,
    cy: 120,
    r: 120
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "shadow-copy-2",
    fillOpacity: 0.2,
    fill: "#004A99",
    filter: "url(#filter-1)",
    points: "93.62 183.631579 145.98 183.631579 145.98 159.571429 93.62 159.571429"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "shadow-copy",
    fillOpacity: 0.2,
    fill: "#004A99",
    filter: "url(#filter-2)",
    points: "53.62 158.631579 97 158.631579 97 134.571429 53.62 134.571429"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "shadow-copy-3",
    fillOpacity: 0.2,
    fill: "#004A99",
    filter: "url(#filter-3)",
    points: "143.62 159.631579 187 159.631579 187 135.571429 143.62 135.571429"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(52.000000, 71.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.8,
    fill: "url(#linearGradient-4)",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-9)",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-7)",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    transform: "translate(141.000000, 71.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-11)",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.8,
    fill: "url(#linearGradient-4)",
    fillRule: "evenodd",
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-13)",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-7)",
    fillRule: "evenodd",
    xlinkHref: "#path-12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(90.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-15)",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-17)",
    xlinkHref: "#path-16"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-16"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllusTeam);
export default __webpack_public_path__ + "static/media/illus-team.5cf91003102c6e3b4049e7c1d02eb8c2.svg";
export { ForwardRef as ReactComponent };